/**
 * Icon-related semantic tokens for PrimeNG preset
 * Icon sizes derived from fontSize primitives (same grid values)
 */
import * as p from '../tokens/primitives.js';

export const icons = {
  // Global icon size (default 1rem / 16px)
  iconSize: p.fontSize.base,

  // Icon size tokens (matched to fontSize scale)
  iconSizes: {
    xs: p.fontSize.xs, // 0.75rem (12px)
    sm: p.fontSize.sm, // 0.875rem (14px)
    base: p.fontSize.base, // 1rem (16px)
    md: p.fontSize.xl, // 1.25rem (20px)
    lg: p.fontSize['2xl'], // 1.5rem (24px)
    xl: p.fontSize['3xl'], // 2rem (32px)
    '2xl': p.fontSize['4xl'], // 2.5rem (40px)
  },

  // Icon
  icon: {
    size: p.fontSize.base, // 1rem (16px)
  },
};
